import { StringMask } from '@/utils/StringMask';
import { NInput } from 'naive-ui';
import { computed, defineComponent, ref, type PropType, watch } from 'vue';

export const AppInputPhone = defineComponent({
    name: 'AppInputPhone',
    extends: NInput, 

    props: {
        modelValue: String,
        phoneType: { type: String as PropType<'Tel' | 'Cel'>, default: 'Cel' },
    },
    emits: ['update:modelValue'],

    setup(props, { emit }) {
        const currentMask = computed(() => {
            return props.phoneType === 'Cel' ? '(00) 00000-0000' : '(00) 0000-0000';
        });

        const fieldMask = computed(() => new StringMask({ mask: currentMask.value }));
        
        const maskedValue = ref(
            props.modelValue?.toString()
                ? fieldMask.value.apply(props.modelValue.toString()).maskedValue
                : '',
        );

        watch(() => props.phoneType, () => {
             handleInput(props.modelValue || '');
        });

        watch(
            () => props.modelValue,
            (value) => {
                if (value !== undefined) {
                    const digits = value.replace(/\D/g, '');
                    const response = fieldMask.value.apply(digits);
                    maskedValue.value = response.maskedValue;
                }
            },
        );

        function handleInput(value: string | undefined) {
            if (!value) {
                maskedValue.value = '';
                emit('update:modelValue', '');
                return;
            }

            const digitsOnly = value.replace(/\D/g, '');
            
            const response = fieldMask.value.apply(digitsOnly);
            maskedValue.value = response.maskedValue;

            emit('update:modelValue', response.maskedValue);
        }

        const placeholder = computed(() => {
            return props.phoneType === 'Cel' ? '(00) 00000-0000' : '(00) 0000-0000';
        });

        return () => (
            <NInput
                {...props}
                placeholder={placeholder.value}
                onInput={handleInput}
                value={maskedValue.value}
                maxlength={currentMask.value.length}
            />
        );
    },
});

export default AppInputPhone;